import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {NguCarousel, NguCarouselStore, NguCarouselService} from '@ngu/carousel';
import {Card} from '../../domain/card';
import {CarouselAction} from '../../domain/card-actions/carousel.action';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

@Component({
  selector: 'crds-carousel-form',
  templateUrl: './carousel-form.component.html',
  styles: [
    `
      :host ::ng-deep ngu-item {
        margin-top: 0.25rem;
      }
    `
  ]
})
export class CarouselFormComponent implements OnInit, AfterViewInit {
  @Input() form: FormGroup;
  @Input() card: Card<CarouselAction>;
  public currentMainSlide: number;
  private mainCarouselToken: string;
  public carouselMain: NguCarousel;
  action: CarouselAction;

  constructor(private carousel: NguCarouselService,
              private sanitizer: DomSanitizer) {
  }

  ngOnInit() {
    this.action = this.card.action;
    this.setCurrentMainSlide(this.getCurrentMainSlideFromForm());
    this.updateTargetField();
    this.carouselMain = {
      grid: {xs: 1, sm: 1, md: 1, lg: 1, all: 0},
      slide: 1,
      point: {
        visible: false
      },
      load: 5,
      touch: true,
      loop: false
    };
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.carousel.moveToSlide(this.mainCarouselToken, this.getCurrentMainSlideFromForm(), false);
    });
  }

  getCurrentMainSlideName() {
    return this.card.action.mainSlides[this.currentMainSlide] ?
      this.card.action.mainSlides[this.currentMainSlide].text :
      '';
  }

  setCurrentMainSlide(slide: number) {
    this.currentMainSlide = slide;
  }

  updateMainSlide(currentSlide: number) {
    if (currentSlide !== this.currentMainSlide) {
      this.setCurrentMainSlide(currentSlide);
      this.updateTargetField();
    }
  }

  updateTargetField() {
    setTimeout(() => {
      this.form.get(this.action.targetField).patchValue(
        this.getCurrentMainSlideName()
      );
    });
  }

  initMainCarousel(key: NguCarouselStore) {
    this.mainCarouselToken = key.token;

  }

  private getCurrentMainSlideFromForm() {
    const currentFormValue = this.form.get(this.action.targetField).value;
    if (!currentFormValue) {
      return 0;
    }
    const currentMainSlideValue = currentFormValue.split(' - ')[0];
    return this.card.action.mainSlides.findIndex(mainSlide => mainSlide.text === currentMainSlideValue);
  }

  toSafeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
